// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalInventoryLogs_root__1G8C1","log":"ModalInventoryLogs_log__3lmQZ","date":"ModalInventoryLogs_date__YCmXD","userName":"ModalInventoryLogs_userName__roqJs"};